import * as React from "react";
import {
  UitkLayoutGrid,
  UitkLayoutGridItem,
  UitkLayoutGridColumnRow,
  UitkLayoutConditionalGridSpan,
} from "uitk-react-layout-grid";
import { UitkText } from "uitk-react-text";
import { UitkCard } from "uitk-react-cards";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { decorateEditorialHtml } from "../../../../ContentUtilities";
import { ContentProps } from "../../../../typings";

export const CitiCalculatorContainer = (props: ContentProps) => {
  const flexComponent = props.flexComponent;
  const model = flexComponent && flexComponent.model;
  const items = (model && model.items && model.items.filter((item) => item)) || [];
  const containerColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 3, large: 3, extra_large: 3 };
  const hotelColSpan: UitkLayoutConditionalGridSpan = { small: 1, medium: 3, large: 3, extra_large: 3 };
  const compareColSpan: UitkLayoutConditionalGridSpan = { small: 1, medium: 1, large: 2, extra_large: 2 };
  const costColSpan: UitkLayoutConditionalGridSpan = { small: 3, medium: 4, large: 3, extra_large: 3 };
  const containerGridColumns = {
    extra_large: 12 as UitkLayoutGridColumnRow,
    large: 12 as UitkLayoutGridColumnRow,
    medium: 12 as UitkLayoutGridColumnRow,
    small: 8 as UitkLayoutGridColumnRow,
  };

  if (!model || items.length !== 6) {
    return null;
  }

  const [flightText, hotelText, totalCostText, totalCostAmount, add, compare] = items.map((item) =>
    decorateEditorialHtml(item.text)
  );

  return (
    <UitkLayoutFlex space="two" wrap="wrap" justifyContent="center" className="all-b-padding-six">
      <UitkLayoutFlexItem grow={1} minWidth="twenty_four" maxWidth="one_hundred_twenty">
        <UitkCard withBorder={true}>
          <div className="uitk-cell">
            <UitkLayoutGrid columns={containerGridColumns} space="six">
              <UitkLayoutGridItem colSpan={containerColSpan}>
                <UitkLayoutGrid columns={1}>
                  <div className="uitk-type-center">
                    <UitkText size={300}>
                      <div className="all-t-padding-six all-l-padding-six" dangerouslySetInnerHTML={flightText} />
                    </UitkText>
                  </div>
                </UitkLayoutGrid>
              </UitkLayoutGridItem>

              <UitkLayoutGridItem colSpan={1}>
                <UitkText size={800}>
                  <div className="uitk-type-center all-t-padding-six all-l-padding-two" dangerouslySetInnerHTML={add} />
                </UitkText>
              </UitkLayoutGridItem>

              <UitkLayoutGridItem colSpan={hotelColSpan}>
                <UitkLayoutGrid columns={1}>
                  <div className="uitk-type-center">
                    <UitkText size={300}>
                      <div
                        className="all-t-padding-six xl-l-padding-six l-l-padding-six m-l-padding-six uitk-type-center s-r-padding-two"
                        dangerouslySetInnerHTML={hotelText}
                      />
                    </UitkText>
                  </div>
                </UitkLayoutGrid>
              </UitkLayoutGridItem>

              <UitkLayoutGridItem colSpan={compareColSpan}>
                <div>
                  <UitkText align="center" size={800}>
                    <div className="all-y-padding-six s-l-padding-two" dangerouslySetInnerHTML={compare} />
                  </UitkText>
                </div>
              </UitkLayoutGridItem>

              <UitkLayoutGridItem colSpan={costColSpan}>
                <UitkLayoutGrid columns={1}>
                  <div className="all-y-padding-six all-r-padding-six">
                    <UitkText align="center" size={300}>
                      <div dangerouslySetInnerHTML={totalCostText} />
                    </UitkText>

                    <UitkText align="center" size={600} weight={"bold"}>
                      <div dangerouslySetInnerHTML={totalCostAmount} />
                    </UitkText>
                  </div>
                </UitkLayoutGrid>
              </UitkLayoutGridItem>
            </UitkLayoutGrid>
          </div>
        </UitkCard>
      </UitkLayoutFlexItem>
    </UitkLayoutFlex>
  );
};
export default CitiCalculatorContainer;
